import { isEmpty } from 'lodash';
import { ALL_MODE, SELECTED_MODE, TAGGED_MODE, TYPE_VOIP, TYPE_WEB, WIRELESS } from '../../ServiceTestsConstants';
import { VOIP_PHONE_TEST_TYPE } from '../../../../panels/voip-test-now-panels/VoipTestConstants';

export const AGENT_PICKER_URL = '/query/admin/agents/picker';

const bttScriptRegex = /from\s*ngp\.v1\.btt\.engine\s*import/;
const ALLOWED_TEST_TYPES = new Set(['DNS', 'portAvailability', 'latency', 'fTP', TYPE_WEB, 'VoipDial', TYPE_VOIP]);

/**
 * Returns true if the given testType is NOT in the allowed set (and is not a BTT script).
 * Used to add excludeGlobal param to agent picker request.
 */
export function isDisAllowedTestType(testType) {
    const matches = (testType?.script || '').match(bttScriptRegex);
    const isBtt = testType?.bttTest === true || (matches && matches.length > 0);
    return !ALLOWED_TEST_TYPES.has(testType?.group) && !isBtt;
}

/**
 * Build query params for the agent picker API endpoint.
 * Mutually exclusive WiFi logic matches portal/ui agents.service.js agentsByTestType() if...else if.
 */
export function buildAgentFilterParams(testType, adapterType) {
    const params = {};
    if (testType?.wifiConnectTest === true) {
        params.dynamicWifi = true;
    } else if (testType?.name === 'wifi' || adapterType === WIRELESS) {
        params.wifi = true;
    }
    if (isDisAllowedTestType(testType)) {
        params.excludeGlobal = true;
    }
    if (testType?.name === VOIP_PHONE_TEST_TYPE) {
        params.voip = true;
    }
    return params;
}

/**
 * Derive the initial agent selection mode from form data.
 * Mirrors portal/ui testAgentsPicker.controller.js initSelectionMode().
 */
export function deriveInitialMode(agents) {
    if (!agents || agents.all) return ALL_MODE;
    if (!isEmpty(agents.ids)) return SELECTED_MODE;
    if (!isEmpty(agents.tags)) return TAGGED_MODE;
    // portal/ui: when all=false, ids=[], tags=[] → returns NONE constant.
    // No radio matches 'none' → no radio selected, matching portal/ui behavior.
    return 'none';
}
